function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_padlock"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m9.872 4.882c.577-.569 1.333-.882 2.128-.882 1.654 0 3 1.346 3 3v4c0 .553.448 1 1 1s1-.447 1-1v-4c0-2.757-2.243-5-5-5-1.324 0-2.579.518-3.532 1.458-.393.388-.398 1.021-.01 1.414s1.021.399 1.414.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12 16c-.552 0-1 .447-1 1v1c0 .553.448 1 1 1s1-.447 1-1v-1c0-.553-.448-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.707 20.293-18-18c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l4.707 4.707v4.586h-1c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h12c.701 0 1.317-.364 1.674-.912l.619.619c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm-12.707-9.879 2.586 2.586h-2.586zm9 9.586h-12v-5h7.586l4.414 4.414z"
})));

var Svg078Padlock = function Svg078Padlock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg078Padlock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/078-padlock.c06b156a.svg";
export { ForwardRef as ReactComponent };